import { define } from 'wicked-elements'

define('[data-component="page-toggle"]', {
  init() {
    this.$input = this.element.querySelector('input')
  },
  onChange() {
    console.log('onChange', this.$input.checked)
    // alert(this.$input.checked)
    // window.GPLA_APP.go(this.element.value)
  },
})
